module.exports = __webpack_public_path__ + "img/c07_unitspearman_Normal_ua.658c7218.webp";